import { getAllOrdersApiRequest, getMyOrdersApiCall } from '@guryou/api-client-gql';

import { PURCHASES_GET_MANY, USER_ALL_ORDERS } from '../types';

import { execute } from './actionWrapper';

const getAllPurchases =
  (silent = false) =>
  async dispatch =>
    execute(dispatch, () => getAllOrdersApiRequest(), PURCHASES_GET_MANY, null, null, silent);
const getMyOrders = () => async dispatch =>
  execute(dispatch, () => getMyOrdersApiCall({ sessions: ['id', 'resourceName', 'startTime', 'endTime'] }), USER_ALL_ORDERS);

export { getAllPurchases, getMyOrders };
